import { injectable } from 'inversify';
import { ReadmissionHistory } from '../services/ReadmissionManagerRunner';
import axios, { AxiosRequestTransformer, AxiosResponseTransformer } from 'axios';
import { ReadmissionStorageInterface } from '../interfaces/ReadmissionStorageInterface';
import { UserService } from '../services/UserService';
import { AxiosReviver, AxiosSerializer, Contexts, NamedBindings, getContainer } from '@dandelion/core';

@injectable()
export class RestReadmissionStorage implements ReadmissionStorageInterface {
  protected STORAGE_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;

  protected axiosInstance = axios.create({
    transformRequest: [
      AxiosSerializer,
      ...(axios.defaults.transformRequest as AxiosRequestTransformer[]),
    ],
    transformResponse: [
      ...(axios.defaults.transformResponse as AxiosResponseTransformer[]),
      AxiosReviver,
    ],
  });
  constructor(
  ) {
    const userService = getContainer(Contexts.SHARED).get(NamedBindings.UserService) as UserService
    this.axiosInstance.interceptors.request.use((config: any) => {
      config.headers = userService.getHeaders();
      return config;
    });
  }

  async save(cryptedHash: string, otherAdmission: ReadmissionHistory[]) {
    await this.axiosInstance.post(
      this.STORAGE_BASE_URL + `Readmission/${cryptedHash}/`, otherAdmission)

    return;
  }

  async delete(cryptedHash: string, index: number) {
    const url = this.STORAGE_BASE_URL + `Readmission/${cryptedHash}/${index}`;
    await this.axiosInstance.delete(url);
  }

  async getPrevAdmissionsHypothesis(cryptedHash: string): Promise<ReadmissionHistory[] | undefined> {
    let data = (await axios.get(this.STORAGE_BASE_URL + `Readmission/${cryptedHash}/`)
    ).data;
    if (data == "") {
      data = [];
    }
    return data;
  }
}
